import { nameChangeReasons } from "../options/nameChangeReason";
import { FormStepType } from "../types";
import {
  docType,
  status,
  firstName,
  lastName,
  documentNumber,
  issuanceDate,
  nameChanged,
} from "./fields/passport-details-fields";
import { travelPlansGroup } from "./fields/travel-plans-fields";

export const passport_details_renewal: FormStepType = {
  id: 3,
  name: "passport-details",
  title: "3. Passport Details",
  groups: [
    {
      name: "issued-documents",
      fields: [docType({ form: "passport-renewal" })],
      subGroups: [
        {
          name: "passport-book",
          title: "U.S Passport Book",
          subTitle: "Your name as printed on your most recent U.S. Passport book",
          condition: {
            field: "documentType2",
            values: ["passportbook", "both"],
          },
          fields: [issuanceDate({}), firstName({}), lastName({}), documentNumber({})],
          cols: 6,
        },
        {
          name: "passport-card",
          title: "U.S Passport Card",
          subTitle: "Your name as printed on your most recent U.S. Passport card",
          condition: {
            field: "documentType2",
            values: ["passportcard", "both"],
          },
          fields: [
            issuanceDate({ type: "card" }),
            firstName({ type: "card" }),
            lastName({ type: "card" }),
            documentNumber({ type: "card" }),
          ],
          cols: 6,
        },
      ],
    },

    {
      name: "name-has-changed",
      fields: [nameChanged({ form: "passport-renewal" })],
    },
    {
      name: "nameChangeSubGroup",
      condition: {
        field: "nameChange",
        value: "yes",
      },
      fields: [
        {
          component: "Radio",
          name: "nameChangeReason",
          label: "Reason for the name change?",
          type: "radio",
          validation: {
            required: "Please select an option.",
          },
          placeholder: "Select your reason",
          options: nameChangeReasons,
          cols: 12,
        },
        {
          component: "Date",
          name: "nameChangeDate",
          label: "Date of issue",
          type: "date",
          maxElegibleDate: "today",
          validation: { required: "Please select a date." },
          cols: 4,
          placeholder: "Please select a date.",
        },
        {
          component: "TextInput",
          name: "nameChangePlace",
          label: "Place of name change (City/State)",
          type: "text",
          placeholder: "",
          cols: 5,
          maxLength: 23,
          validation: {
            required: "Please enter the place of name change.",
            maxLength: 23,
            minLength: {
              value: 2,
              message: "The place of name change must have at least two characters.",
            },
          },
        },
      ],
    },
    travelPlansGroup,
  ],
};
